import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';
import { moduleConfig } from './config';
import {
  buildListQuery,
  ListQueryOptions,
  normalizePaginatedListResponse,
  PaginatedApiResponse,
} from '../../../services/paginatedList';

type CodeName = { id: number; code?: string | null; name?: string | null };
type VesselRef = {
  id: number;
  vesselName?: string | null;
  vesselAbrv?: string | null;
  name?: string | null;
  abrv?: string | null;
};

export interface PmsDepartment {
  id: number;
  vesselId: number;
  typeId: number;
  recordStatusId: number;
  parentDepartmentId?: number | null;
  code: string;
  name: string;
  description?: string | null;
  displayOrder?: number | null;
  isActive?: boolean;
  vessel?: VesselRef | null;
  type?: CodeName | null;
  recordStatus?: CodeName | null;
  parentDepartment?: CodeName | null;
  createdAt?: string;
  updatedAt?: string;
  [key: string]: unknown;
}

export const usePmsDepartments = (
  searchParams?: string,
  page = 1,
  limit = 25,
  options?: ListQueryOptions,
) => {
  const q = buildListQuery(searchParams, page, limit, options);
  const { data, error, isLoading, mutate } = useSWR<
    PaginatedApiResponse<PmsDepartment> | PmsDepartment[]
  >(`${moduleConfig.module.api.list}${q}`, fetcher, { revalidateOnFocus: true });
  const normalized = normalizePaginatedListResponse<PmsDepartment>(data, page, limit);
  return {
    data: normalized.data,
    clients: normalized.data,
    total: normalized.total,
    page: normalized.page,
    limit: normalized.limit,
    isLoading,
    isError: error,
    mutate,
  };
};

export const usePmsDepartment = (id?: number) => {
  const { data, error, isLoading, mutate } = useSWR<PmsDepartment>(
    id != null && Number.isFinite(id) && id > 0 ? moduleConfig.module.api.detail(id) : null,
    fetcher,
    { revalidateOnFocus: true },
  );
  return { data, item: data, isLoading, isError: error, mutate };
};
